const config = {
  APP_URL: process.env.REACT_APP_API_URL || "REACT_APP_API_URL_PLACEHOLDER",
  APP_NAME: process.env.REACT_APP_NAME || "REACT_APP_NAME_PLACEHOLDER",
  //   APP_COMPANY_NAME: process.env.APP_COMPANY_NAME,
};
export default config;
